'use strict';
const angular = require('angular');
const _ = require('lodash');

export class bodyDiagramComponent {
  //selected = ['head', 'left-foot', 'right-foot'];
  ngModel = [];
  parts = require('./bodyPartData.js');

  /*@ngInject*/
  constructor() {
    this.message = 'World';
  }

  checkClick(part) {
    if(this.ngModel == undefined) {
      this.ngModel = [];
    }

    console.log('checking:', part);
    if(_.indexOf(this.ngModel, part.bodypart) >= 0) {
      _.pull(this.ngModel, part.bodypart);
    } else {
      this.ngModel.push(part.bodypart);
    }
  }

  checkSelected(part) {
    if(!part.id) {
      return part.color;
    }

    if(_.indexOf(this.ngModel, part.bodypart) >= 0) {
      return '#FF0000';
    }

    return '#cccccc';
  }
}

export default angular.module('hccApp.bodyDiagram', [])
  .component('bodyDiagram', {
    template: require('./bodyDiagram.html'), //'<h1>Hello {{ $ctrl.message }}</h1>',
    bindings: {
      ngModel: '='
    },
    controller: bodyDiagramComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/components/bodyDiagram/bodyDiagram.component.js